import { CircleHelp, X } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { getHelpStatus } from './api';
import { HelpChatPanel } from './HelpChatPanel';
import { useHelpPage } from './pageContext';

/**
 * Floating assistant launcher, mounted in AppLayout and HandbookLayout. Gated
 * on GET /help/status so environments without a platform key (or handbook)
 * simply never show it. The panel stays MOUNTED once opened — closing hides it,
 * so the transcript survives.
 */
export function HelpLauncher() {
  const [available, setAvailable] = useState(false);
  const [open, setOpen] = useState(false);
  const [openedOnce, setOpenedOnce] = useState(false);
  // The console's own path doubles as handbook context: CRM articles carry
  // these exact routes in their frontmatter.
  const { pathname } = useLocation();
  const page = useHelpPage();

  useEffect(() => {
    let cancelled = false;
    getHelpStatus()
      .then((status) => {
        if (!cancelled) setAvailable(status.available);
      })
      .catch(() => undefined);
    return () => {
      cancelled = true;
    };
  }, []);

  if (!available) return null;

  return (
    <>
      {openedOnce && (
        <div className="hc-pop" hidden={!open}>
          <div className="hc-pop-head">
            <CircleHelp size={16} />
            <span>LimoSphere assistant</span>
            <button type="button" className="hc-pop-close" aria-label="Close assistant" onClick={() => setOpen(false)}>
              <X size={15} />
            </button>
          </div>
          <HelpChatPanel routeContext={pathname} pageContext={page} />
        </div>
      )}
      {/* The launcher is also the closer, so it has to LOOK like one while the
          panel is up — an unchanged icon reads as "still just help". */}
      <button
        type="button"
        className={open ? 'hc-fab hc-fab-open' : 'hc-fab'}
        aria-label={open ? 'Close the assistant' : 'Ask the assistant'}
        title={open ? 'Close the assistant' : 'Ask the assistant'}
        onClick={() => {
          setOpenedOnce(true);
          setOpen((value) => !value);
        }}
      >
        {open ? <X size={20} /> : <CircleHelp size={20} />}
      </button>
    </>
  );
}
